var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-right"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'designations.create' }}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'plus-circle']}}),_vm._v("\n      Create\n    ")],1)],1),_c('div',{ref:"tree",staticClass:"org-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }